import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Results } from "./components/results";
import { Survey } from "./components/survey";
import "./App.css";
import { ReactSession } from "react-client-session";
import { useEffect, useContext } from "react";
import { ReviewContext, ReviewProvider } from "./lib/review-context";

const AppWithReviews = () => {
  const { submittedReview, refreshReviews, clearSession } =
    useContext(ReviewContext);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    refreshReviews(true);
  }, []);

  useEffect(() => {
    if (!location || !navigate) {
      return;
    }

    if (location.search.includes("clear=true")) {
      clearSession();
      return;
    }

    if (location.pathname !== "/results" && submittedReview) {
      navigate("../results");
    }
  }, [navigate, location, submittedReview, clearSession]);

  useEffect(() => {
    if (!location) {
      return;
    }

    window.scrollTo(0, 0);
    ReactSession.setStoreType("localStorage");
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Survey />} />
      <Route path="results" element={<Results />} />
    </Routes>
  );
};

const App = () => {
  return (
    <Wrapper id="js-main-app-wrapper">
      <InnerWrapper>
        <ReviewProvider>
          <AppWithReviews />
        </ReviewProvider>
      </InnerWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;

  padding: 24px;

  @media (min-width: 768px) {
    padding: 10vh 24px;
  }
`;

const InnerWrapper = styled.div`
  max-width: 550px;
  height: 100%;
  width: 100%;
`;

export default App;
